import { Component, OnInit, Renderer2, Input, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { tPatientModel } from 'src/app/models/tPatientModel';
import { tEmployeeModel } from 'src/app/models/tEmployeeModel';
import { tItemModel } from 'src/app/models/tItemModel';
import { tBookingTimeModel } from 'src/app/models/tBookingModel';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { SearchEmployeeDialogService } from 'src/app/services/Non-Master/SearchEmployeeDialog.service';
import { tPatientService } from 'src/app/services/tPatient.service';
import { DatePipe } from '@angular/common';
import { ApiResultHandlerService } from 'src/app/services/Non-Master/ApiResultHandler.service';
import { SearchItemIDDialogService } from 'src/app/services/Non-Master/SearchItemIDDialog.service';
import { tBookingService } from 'src/app/services/tBooking.service';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { TranslateService } from '@ngx-translate/core';
import { AppSettings } from 'src/app/shared/AppSettings';
import { StatusMessage } from 'src/app/shared/StatusMessage';
import { tBookAuxModel } from 'src/app/models/tBookAuxModel';
import { tBookAuxService } from 'src/app/services/tBookAux.service';

import { CreateWaitingConsultService } from 'src/app/services/Non-Master/CreateWaitingConsult.service';
import { MastersKeyStringValue } from 'src/app/services/Non-Master/MastersKeyStringValue.service';
import { isNullOrUndefined } from 'util';
import { of } from 'rxjs';
import { Router } from '@angular/router';
import { PathAction } from 'src/app/models/non-master-model/PathAction';
import { DisplayData } from 'src/app/models/non-master-model/DisplayData';

import { ApiResultDialogService } from 'src/app/services/Non-Master/ApiResultDialog.service';
import { CustomConfirmDialogService } from 'src/app/services/Non-Master/CustomConfirmDialog.service';
import { SystemDefaultModel } from 'src/app/models/non-master-model/SystemDefaultModel';
import { tShopModel } from 'src/app/models/tShopModel';
import { tEmployeeService } from 'src/app/services/tEmployee.service';
import { CrypService } from 'src/app/services/Non-Master/Cryp.service';
import { tOnConsultService } from 'src/app/services/tOnConsult.service';

@Component({
  selector: 'app-edit-booking-dialog',
  templateUrl: './edit-booking-dialog.component.html',
  styleUrls: ['./edit-booking-dialog.component.css']
})
export class EditBookingDialogComponent implements OnInit {

  //form
  //form
  bntStyle: string;
  submitted = false;
  editForm: FormGroup;

  bookingDateDisplay: string;
  selectedPatient: tPatientModel = new tPatientModel();

  selectedEmpolyee1: tEmployeeModel = new tEmployeeModel();
  selectedEmpolyee1_Display: string;
  selectedItemService1: tItemModel = new tItemModel();
  selectedItemService1_Display: string;


  selectedEmpolyee2: tEmployeeModel = new tEmployeeModel();
  selectedEmpolyee2_Display: string;
  selectedItemService2: tItemModel = new tItemModel();
  selectedItemService2_Display: string;

  selectedEmpolyee3: tEmployeeModel = new tEmployeeModel();
  selectedEmpolyee3_Display: string;
  selectedItemService3: tItemModel = new tItemModel();
  selectedItemService3_Display: string;


  selectedEmpolyee4: tEmployeeModel = new tEmployeeModel();
  selectedEmpolyee4_Display: string;
  selectedItemService4: tItemModel = new tItemModel();
  selectedItemService4_Display: string;


  bookingPatientDisplayName: string;

  timeSlotList: tBookingTimeModel[];
  bookingAuxList: tBookAuxModel[];

  bookingTimeSlotID: any;

  bookAuxForm: FormGroup;
  bookAuxList = [];

  action_delete = MastersKeyStringValue.ACTION_DELETE;
  ecTypeSelectList: tEmployeeModel[];

  i18n;

  constructor(
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private formBuilder: FormBuilder,
    private searchEmployeeDialogService: SearchEmployeeDialogService,
    private tPatientService: tPatientService,
    private tBookingService: tBookingService,
    private searchItemIDDialogService: SearchItemIDDialogService,
    private ren: Renderer2,
    private datepipe: DatePipe,
    private apiResultHandlerService: ApiResultHandlerService,
    private translate: TranslateService,
    private tBookAuxService: tBookAuxService,
    private CreateWaitingConsultService: CreateWaitingConsultService,
    private router: Router,
    private apiResultDialogService: ApiResultDialogService,
    private customConfirmDialogService: CustomConfirmDialogService,
    private employeeService: tEmployeeService,
    private CrypService: CrypService,
    private tOnConsultService : tOnConsultService,
    private datePipe : DatePipe
  ) {

    this.translate.get(['msg_caseDoctor_no_select_patient','msg_caseDoctor_no_caseDoctor']).subscribe(t=>this.i18n=t);
  }

  TAG = 'EditBookingDialogComponent';

  // displayMsg: string;
  @Input() action: string;
  // @Input() status: string;
  @Input() tableKeyValue: string;
  // @Input() msg: string;
  //  @Input() bookingDate: Date;
  @Input() bookingNum: string;
  @Input() patientID: string;

  /*
  1 : booking; 2: arrive
  */
  @Input() formCaseNum: number;

  // checkbox
  // bookingAuxForm: FormGroup;
  bookingAuxData = [];


  ngOnInit() {
    this.getEC_AllowSelectList();
    this.bntStyle = 'btn-default';

    this.log.i(this.TAG, ' formCaseNum = ' + this.formCaseNum);
    //  this.bookingDateDisplay = this.dateTimeConvertService.ConvertCurrentDayWeek(this.bookingDate);

    this.editForm = this.formBuilder.group({
      shopID: [],
      bkBookingNumber: [],
      bkPatientID: ['', [Validators.required]],
      bkBookedDate: [],
      bkBookedTimeSlot: [this.bookingTimeSlotID],
      bkBookingStatus: ['OPEN'],
      // bkBookAuxID: [new tBookAuxModel[].toString()],
      bkBookAuxID: [],
      bkBookAuxIDAll: new FormArray([]),

      bkBookAuxName: ['', ''],

      bkItemID1: ['', ''],
      bkItemDescMobile1: [''],
      bkTherapistID1: ['', ''],
      bkTherapistName1: ['', ''],

      bkItemID2: ['', ''],
      bkItemDescMobile2: [''],
      bkTherapistID2: ['', ''],
      bkTherapistName2: ['', ''],

      bkItemID3: ['', ''],
      bkItemDescMobile3: [''],
      bkTherapistID3: ['', ''],
      bkTherapistName3: ['', ''],

      bkPatientPhone: ['', [Validators.required]],
      bkDoctorID: ['', ''],
      bkDoctorName: ['', ''],
      lastModifyDatetime: ['', ''],
      lastModifyUserID: [],
      bkBookRemark: ['', ''],

      bkItemID4: ['', ''],
      bkItemDescMobile4: [''],
      bkTherapistID4: ['', ''],
      bkTherapistName4: ['', ''],
      bkPatientName:['', [Validators.required]]
    });



  }


  getAllData(): void {

    // init data
    this.tBookingService.getBookingTimeSlot().subscribe(data => {
      this.timeSlotList = data;
      //   this.log.i(this.TAG, "getBookingTimeSlot dataList = " + JSON.stringify(this.timeSlotList));
    });

    this.tBookingService.getBookingNumberInfo(NavigationComponent.selectedShopID, this.bookingNum, this.patientID).subscribe(data => {
      // this.timeSlotList = data;
      this.log.i(this.TAG, 'getBookingNumberInfo getDataById = ' + JSON.stringify(data));
      this.editForm.patchValue(data);

      // this.selectedItemService1_Display = this.selectedItemService1.itemDesc + " (" + this.selectedItemService1.itemID + ")";

      if (data.bkItemID1 != null && data.bkItemID1 != undefined && data.bkItemID1 != '') {
        this.selectedItemService1_Display = data.bkItemDescMobile1 + ' (' + data.bkItemID1 + ')';
      }

      if (data.bkItemID2 != null && data.bkItemID2 !== undefined && data.bkItemID2 !== '') {
        this.selectedItemService2_Display = data.bkItemDescMobile2 + ' (' + data.bkItemID2 + ')';
      }

      if (data.bkItemID3 != null && data.bkItemID3 !== undefined && data.bkItemID3 !== '') {
        this.selectedItemService3_Display = data.bkItemDescMobile3 + ' (' + data.bkItemID3 + ')';
      }

      if (data.bkItemID4 != null && data.bkItemID4 !== undefined && data.bkItemID4 !== '') {
        this.selectedItemService4_Display = data.bkItemDescMobile4 + ' (' + data.bkItemID4 + ')';
      }


      if (data.bkTherapistID1 != null && data.bkTherapistID1 !== undefined && data.bkTherapistID1 !== '') {
        this.selectedEmpolyee1_Display = data.bkTherapistName1 + ' (' + data.bkTherapistID1 + ')';
      }

      if (data.bkTherapistID2 != null && data.bkTherapistID2 !== undefined && data.bkTherapistID2 !== '') {
        this.selectedEmpolyee2_Display = data.bkTherapistName2 + ' (' + data.bkTherapistID2 + ')';
      }

      if (data.bkTherapistID3 != null && data.bkTherapistID3 !== undefined && data.bkTherapistID3 !== '') {
        this.selectedEmpolyee3_Display = data.bkTherapistName3 + ' (' + data.bkTherapistID3 + ')';
      }

      if (data.bkTherapistID4 != null && data.bkTherapistID4 !== undefined && data.bkTherapistID4 !== '') {
        this.selectedEmpolyee4_Display = data.bkTherapistName4 + ' (' + data.bkTherapistID4 + ')';
      }

      //console.log("bkDoctorName:"+data.bkDoctorName);
      (<FormControl>this.editForm.controls['bkDoctorName']).setValue(data.bkDoctorName);

      (<FormControl>this.editForm.controls['bkDoctorID']).setValue(data.bkDoctorID);
     // console.log("bkDoctorName2:"+this.editForm.get('bkDoctorName').value);
      this.getBookAuxService(JSON.parse(data.bkBookAuxID));

      // this.selectedPatient = data.bkPatientID
      if(this.patientID!='newPatient'){
              this.tPatientService.getDataById(NavigationComponent.selectedShopID.toString(), data.bkPatientID).subscribe(data => {

        this.selectedPatient = data;

        this.getPatientLastPhysioInfo();


        // this.bookingPatientDisplayName = data.patientChiName;
        const {patientChiName,patientID,patientSurname} = data;
        this.bookingPatientDisplayName = patientSurname ? `${patientChiName}   ${patientSurname} (${patientID})` : `${patientChiName} (${patientID})`;


        if (!isNullOrUndefined(localStorage.getItem('action'))) {

          if (localStorage.getItem('action') === PathAction.fromEditBookingDialogSaved) {

            const displayData = new DisplayData;

            displayData.displayData1 = '已儲存';
            displayData.displayData2 = data.patientChiName + '(' + data.patientID + ')';

            const msg = ' ' + displayData.displayData1 + ' ' + displayData.displayData2;

            this.apiResultDialogService.openDialog(MastersKeyStringValue.ACTION_MessageDialog, '', status, msg);

          }
          localStorage.removeItem('action');
        }

      });
      }


    });

  }

  getBookAuxService(bookedAux: tBookAuxModel[]) {

    this.tBookAuxService.getDataByInactiveStatus(NavigationComponent.selectedShopID, 'N').subscribe(data => {
      this.bookingAuxList = data.sort((a,b)=>a.bookAuxSeq-b.bookAuxSeq);
    //  this.log.i(this.TAG, 'bookAux bookingAuxList = ' + JSON.stringify(this.bookingAuxList));

      // getcheckbox
      if (this.bookingAuxList.length > 0) {
        this.makeBookingAuxCheckBox(this.bookingAuxList, bookedAux);
      }

    });
  }

  searchEmployee(caseNum: number) {
    this.log.i(this.TAG, 'searchEmployee caseNum = ' + caseNum);

    this.searchEmployeeDialogService.openDialog(caseNum).result.then((result) => {
     // this.log.i(this.TAG, 'searchEmployee data = ' + result);

      if (caseNum === 1) {
        this.selectedEmpolyee1 = result;

        (<FormControl>this.editForm.controls['bkTherapistID1']).setValue(this.selectedEmpolyee1.employeeID);
        (<FormControl>this.editForm.controls['bkTherapistName1']).setValue(this.selectedEmpolyee1.employeeChiName);

        this.selectedEmpolyee1_Display = this.selectedEmpolyee1.employeeChiName + ' (' + this.selectedEmpolyee1.employeeID + ')';

      } else if (caseNum === 2) {
        this.selectedEmpolyee2 = result;

        (<FormControl>this.editForm.controls['bkTherapistID2']).setValue(this.selectedEmpolyee2.employeeID);
        (<FormControl>this.editForm.controls['bkTherapistName2']).setValue(this.selectedEmpolyee2.employeeChiName);

        this.selectedEmpolyee2_Display = this.selectedEmpolyee2.employeeChiName + ' (' + this.selectedEmpolyee2.employeeID + ')';

      } else if (caseNum === 3) {
        this.selectedEmpolyee3 = result;
        // this.editForm.get('bkTherapistID3').setValue(this.selectedEmpolyee3.employeeID);
        (<FormControl>this.editForm.controls['bkTherapistID3']).setValue(this.selectedEmpolyee3.employeeID);
        (<FormControl>this.editForm.controls['bkTherapistName3']).setValue(this.selectedEmpolyee3.employeeChiName);

        this.selectedEmpolyee3_Display = this.selectedEmpolyee3.employeeChiName + ' (' + this.selectedEmpolyee3.employeeID + ')';

      } else if (caseNum === 4) {
        this.selectedEmpolyee4 = result;
        // this.editForm.get('bkTherapistID3').setValue(this.selectedEmpolyee3.employeeID);
        (<FormControl>this.editForm.controls['bkTherapistID4']).setValue(this.selectedEmpolyee4.employeeID);
        (<FormControl>this.editForm.controls['bkTherapistName4']).setValue(this.selectedEmpolyee4.employeeChiName);

        this.selectedEmpolyee4_Display = this.selectedEmpolyee4.employeeChiName + ' (' + this.selectedEmpolyee4.employeeID + ')';

      }

      // this.bookingPatientDisplayName = this.selectedPatient.patientChiName + " ("+this.selectedPatient.patientID+")";

    }, (reason) => {
      this.log.i(this.TAG, 'searchEmployee reason = ' + reason);

    });

  }



  searchService(caseNum: number) {
    this.log.i(this.TAG, 'searchService caseNum = ' + caseNum);


    this.searchItemIDDialogService.openDialogWithSelectFilter(SearchItemIDDialogService.Filter_Search_Service_Only).result.then((result) => {
   //   this.log.i(this.TAG, 'searchService data = ' + result);

      if (caseNum === 1) {
        this.selectedItemService1 = result;

        (<FormControl>this.editForm.controls['bkItemID1']).setValue(this.selectedItemService1.itemID);
        (<FormControl>this.editForm.controls['bkItemDescMobile1']).setValue(this.selectedItemService1.itemDesc);

        this.selectedItemService1_Display = this.selectedItemService1.itemDesc + ' (' + this.selectedItemService1.itemID + ')';

      } else if (caseNum === 2) {
        this.selectedItemService2 = result;

        (<FormControl>this.editForm.controls['bkItemID2']).setValue(this.selectedItemService2.itemID);
        (<FormControl>this.editForm.controls['bkItemDescMobile2']).setValue(this.selectedItemService2.itemDesc);

        this.selectedItemService2_Display = this.selectedItemService2.itemDesc + ' (' + this.selectedItemService2.itemID + ')';

      } else if (caseNum === 3) {
        this.selectedItemService3 = result;

        (<FormControl>this.editForm.controls['bkItemID3']).setValue(this.selectedItemService3.itemID);
        (<FormControl>this.editForm.controls['bkItemDescMobile3']).setValue(this.selectedItemService3.itemDesc);

        this.selectedItemService3_Display = this.selectedItemService3.itemDesc + ' (' + this.selectedItemService3.itemID + ')';

      } else if (caseNum === 4) {
        this.selectedItemService4 = result;

        (<FormControl>this.editForm.controls['bkItemID4']).setValue(this.selectedItemService4.itemID);
        (<FormControl>this.editForm.controls['bkItemDescMobile4']).setValue(this.selectedItemService4.itemDesc);

        this.selectedItemService4_Display = this.selectedItemService4.itemDesc + ' (' + this.selectedItemService4.itemID + ')';

      }

      // this.bookingPatientDisplayName = this.selectedPatient.patientChiName + " ("+this.selectedPatient.patientID+")";

    }, (reason) => {
      this.log.i(this.TAG, 'searchEmployee reason = ' + reason);

    });
  }

  setDatePickerZ() {
    const el = document.getElementsByClassName('mat-datepicker-popup').item(0);
    this.ren.setStyle(el, 'z-index', '1500');
  }

  ClearSelectedItem(caseNum: number) {
    this.log.i(this.TAG, 'ClearSelectedItem caseNum = ' + caseNum);

    if (caseNum === 1) {
      this.selectedItemService1 = null;
      this.selectedItemService1_Display = '';


      (<FormControl>this.editForm.controls['bkItemID1']).setValue('');
      (<FormControl>this.editForm.controls['bkItemDescMobile1']).setValue('');
    } else if (caseNum === 2) {
      this.selectedItemService2 = null;
      this.selectedItemService2_Display = '';


      (<FormControl>this.editForm.controls['bkItemID2']).setValue('');
      (<FormControl>this.editForm.controls['bkItemDescMobile2']).setValue('');
    } else if (caseNum === 3) {

      this.selectedItemService3 = null;
      this.selectedItemService3_Display = '';

      (<FormControl>this.editForm.controls['bkItemID3']).setValue('');
      (<FormControl>this.editForm.controls['bkItemDescMobile3']).setValue('');
    } else if (caseNum === 4) {

      this.selectedItemService4 = null;
      this.selectedItemService4_Display = '';

      (<FormControl>this.editForm.controls['bkItemID4']).setValue('');
      (<FormControl>this.editForm.controls['bkItemDescMobile4']).setValue('');
    }


  }

  ClearSelectedEmpolyee(caseNum: number) {
    this.log.i(this.TAG, 'ClearSelectedEmpolyee caseNum = ' + caseNum);

    if (caseNum === 1) {
      this.selectedEmpolyee1 = null;
      this.selectedEmpolyee1_Display = '';
      (<FormControl>this.editForm.controls['bkTherapistID1']).setValue('');
      (<FormControl>this.editForm.controls['bkTherapistName1']).setValue('');

    } else if (caseNum === 2) {
      this.selectedEmpolyee2 = null;
      this.selectedEmpolyee2_Display = '';

      (<FormControl>this.editForm.controls['bkTherapistID2']).setValue('');
      (<FormControl>this.editForm.controls['bkTherapistName2']).setValue('');
    } else if (caseNum === 3) {
      this.selectedEmpolyee3 = null;
      this.selectedEmpolyee3_Display = '';

      (<FormControl>this.editForm.controls['bkTherapistID3']).setValue('');
      (<FormControl>this.editForm.controls['bkTherapistName3']).setValue('');

    } else if (caseNum === 4) {
      this.selectedEmpolyee4 = null;
      this.selectedEmpolyee4_Display = '';

      (<FormControl>this.editForm.controls['bkTherapistID4']).setValue('');
      (<FormControl>this.editForm.controls['bkTherapistName4']).setValue('');

    }

  }


  get f() { return this.editForm.controls; }

  update() {

    // this.activeModal.dismiss();
    this.log.i(this.TAG, 'do update patientID' + this.selectedPatient.patientID + ' , bookedDate = ' + this.editForm.get('bkBookedDate'));

    this.submitted = true;
    var checkPatientPhone=this.trimLeadingSpaces(this.editForm.get("bkPatientPhone").value.toString());
    var checkPatientName= this.trimLeadingSpaces(this.editForm.get("bkPatientName").value.toString());
    this.editForm.get("bkPatientPhone").setValue(checkPatientPhone);
    this.editForm.get("bkPatientName").setValue(checkPatientName);

    if (this.editForm.valid) {
      //test change employeeChiName when employeeChiName changed and user not click changeTherapistID() agian
      this.editForm.patchValue({bkDoctorName:this.ecTypeSelectList.find(z=>z.employeeID == this.editForm.get('bkDoctorID').value).employeeChiName});

      console.table(this.editForm.value);
      debugger
      // (<FormControl>this.editForm.controls['bkBookedDate']).setValue(this.datepipe.transform(this.bookingDate, 'yyyy-MM-dd'));
      let returnDisplayMsg: string;


      (<FormControl>this.editForm.controls['lastModifyUserID']).setValue(NavigationComponent.userID);


      // ---start get aux
      const auxList: tBookAuxModel[] = new Array();
      const selectedOrderIds = this.editForm.value.bkBookAuxIDAll
        .map((v, i) => (v ? this.bookingAuxList[i].bookAuxID : null))
        .filter(v => v !== null);

      this.log.i(this.TAG, 'selectedOrderIds data = ' + selectedOrderIds
        + ' , selectedOrderIds size = ' + selectedOrderIds.length);

      for (let pp = 0; pp < this.bookingAuxList.length; pp++) {
        for (let qq = 0; qq < selectedOrderIds.length; qq++) {
          if (selectedOrderIds[qq] === this.bookingAuxList[pp].bookAuxID) {
            auxList.push(this.bookingAuxList[pp]);
            break;
          }
        }
      }
      // this.log.i(this.TAG, 'auxList data = ' + JSON.stringify(auxList).toString());

      (<FormControl>this.editForm.controls['bkBookAuxID']).setValue(JSON.stringify(auxList).toString());
      // ---end get aux




      this.log.i(this.TAG, 'onSubmit data = ' + JSON.stringify(this.editForm.value));

      this.tBookingService.updateData(this.editForm.value)
        .subscribe(data => {
          const returnData: any = data;

          if (returnData.statusCode === StatusMessage.Status_OK) {
            this.activeModal.close(StatusMessage.Status_OK);
          }

          this.log.i(this.TAG, 'update success... return msg = ' + returnDisplayMsg);

          // this.router.navigate(['/bed']);
          // this.apiResultHandlerService.ResultHandler(
          //   data,
          //   AppSettings.Path_Booking + AppSettings.PATH_NEW,
          //   '');


          const diaplayData = new DisplayData;




          diaplayData.displayData1 = '已儲存';
          diaplayData.displayData2 = this.editForm.get('bkPatientName').value;

          for (var pp = 0; pp < this.timeSlotList.length; pp++) {
            if (this.editForm.get('bkBookedTimeSlot').value == this.timeSlotList[pp].bookingTimeID) {
              diaplayData.displayData3 = ' 預約 '+this.editForm.get('bkBookedDate').value+' '+ this.timeSlotList[pp].bookingTime;

            }
          }
          diaplayData.displayData4 = '';
          diaplayData.displayData5 = '';

          this.log.i(this.TAG,"diaplayData = "+diaplayData +" , bookingTimeSlotID = "+this.bookingTimeSlotID);
          // show result dialog
          this.apiResultHandlerService.ResultHandlerWithDisplayDate(
            data,
            AppSettings.Path_Booking + AppSettings.PATH_NEW,
            '',
            diaplayData);

        }, error => {
          this.log.i(this.TAG, 'onsubmit error = ' + JSON.stringify(error));
          this.apiResultHandlerService.ErrHandler();
        });

    }

  }

  onAuxChange(auxID) {
    this.log.i(this.TAG, 'onAuxChange auxID = ' + auxID);

    if (isNullOrUndefined(this.bookingAuxList)) {
      return;
    }

    for (let i = 0; i < this.bookingAuxList.length; i++) {
      if (auxID === this.bookingAuxList[i].bookAuxID) {
        (<FormControl>this.editForm.controls['bkBookAuxName']).setValue(this.bookingAuxList[i].bookAuxName);

        break;
      }
    }
  }

  trimLeadingSpaces(str: any): string {

      return str.replace(/^\s+/, '');

  }
  ClearSelectBookAux() {
    (<FormControl>this.editForm.controls['bkBookAuxID']).setValue(0);
    (<FormControl>this.editForm.controls['bkBookAuxName']).setValue('');
  }

  newWaitingConsult() {
    // this.log.i(this.TAG, 'newWaitingConsult');

    // this.activeModal.dismiss('Cross click');

    // this.CreateWaitingConsultService.openDialog(
    //   MastersKeyStringValue.ACTION_NEW,
    //   MastersKeyStringValue.TABLE_ConsultHead,
    //   this.bookingNum,
    //   this.patientID,
    //   this.patientName
    //   ,
    //   2
    // ).result.then((result) => {
    //   // on close
    //   this.log.i(this.TAG, 'newBookingRecord data = ' + result);
    //   if (result === StatusMessage.Status_OK) {
    //   }

    // }, (reason) => {
    //   this.log.i(this.TAG, 'newBookingRecord reason = ' + reason);

    // });
  }


  deleteBooking() {

    this.log.i(this.TAG, 'deleteBooking');
    // this.customConfirmDialogService.openDialog(this.action_delete, this.tableKeyValue, data);
    // NavigationComponent.selectedShopID, this.bookingNum, this.patientID
    // this.tBookingService.deleteData()
    // .getBookingTimeSlot().subscribe(data => {
    //   this.timeSlotList = data;
    //   //   this.log.i(this.TAG, "getBookingTimeSlot dataList = " + JSON.stringify(this.timeSlotList));
    // });

    if (confirm("確定要刪除嗎？")) {
      this.tBookingService.deleteData(NavigationComponent.selectedShopID, this.bookingNum, this.patientID, NavigationComponent.userID.toString()).subscribe(data => {
        // this.timeSlotList = data;
        //   this.log.i(this.TAG, "getBookingTimeSlot dataList = " + JSON.stringify(this.timeSlotList));
        //this.activeModal.dismiss('Cross click');
        this.activeModal.close(StatusMessage.Status_OK);

      });
    }

  }


  // checkbox
  makeBookingAuxCheckBox(bookAuxAllList: tBookAuxModel[], bookedAuxList: tBookAuxModel[]) {

    of(bookAuxAllList).subscribe(bookAuxList => {
      this.bookingAuxData = bookAuxList;
      this.addCheckboxes(bookedAuxList);
    });
  }

  private addCheckboxes(bookedAuxList: tBookAuxModel[]) {
    this.bookingAuxData.forEach((o, i) => {
      // const control = new FormControl(i === 0); // if first item set to true, else false
      let control = new FormControl();
      const checkBookingModel: tBookAuxModel = this.bookingAuxData[i];

      for (let pp = 0; pp < bookedAuxList.length; pp++) {

        if (bookedAuxList[pp].bookAuxID === checkBookingModel.bookAuxID) {
          control = new FormControl(i === i);
          break;
        }
      }
      // this.log.i(this.TAG," i = "+i+" , value = "+JSON.stringify(this.bookingAuxData[i]));
      (this.editForm.controls.bkBookAuxIDAll as FormArray).push(control);
    });
  }

  editPatient() {
    localStorage.removeItem('action');
    localStorage.setItem('action', PathAction.fromEditBookingDialog);

    localStorage.removeItem('systemPatientShopID');
    localStorage.setItem('systemPatientShopID', NavigationComponent.selectedShopID.toString());

    localStorage.removeItem('systemMasterPatientID');
    localStorage.setItem('systemMasterPatientID', this.patientID);

    localStorage.removeItem('bookingNum');
    localStorage.setItem('bookingNum', this.bookingNum);


    this.router.navigate([AppSettings.Path_tPatient + AppSettings.PATH_EDIT]);

    this.activeModal.dismiss('Cross click');
  }


  GetAuxListAll(form) {
    // editForm.controls.bkBookAuxIDAll.controls
    var auxListForm: FormGroup = this.formBuilder.group({
      bkBookAuxIDAll: new FormArray([]),
    });

    return form.controls;
  }

  changeTherapistID() {
    this.log.i(this.TAG, "do changeTherapistID");
    for (let i = 0; i < this.ecTypeSelectList.length; i++) {
      // this.ecTypeSelectList[i].fromToWH = this.editForm.get('fromToWH').value;

      if (this.ecTypeSelectList[i].employeeID == this.editForm.get('bkDoctorID').value) {
        (<FormControl>this.editForm.controls['bkDoctorName']).setValue(this.ecTypeSelectList[i].employeeChiName);
        break;
      }
      // this.log.i(this.TAG, i + ' , fromToWH = ' + this.ecTypeSelectList[i].fromToWH + ' ,whWhseID.whWhseID = ' + this.editForm.get('fromToWH').value);

    }

    // this.dataSource = new MatTableDataSource<tInvtModel>(this.dataList);

  }
  getEC_AllowSelectList() {
    // ecAllowSelectList
    this.employeeService.getEmployeeTypeList(NavigationComponent.selectedShopID, 5).subscribe(data => {
      // this.timeSlotList = data;
       this.log.i(this.TAG, 'getEmployeeTypeList  = ' + JSON.stringify(data));

      this.ecTypeSelectList = [];
      //filter
      for (var i = 0; i < data.empolyeeList.length; i++) {
        //check need put
        var checkingEmployeeShopList: tShopModel[] = JSON.parse(data.empolyeeList[i].employeeRemark1);

        for (var p = 0; p < checkingEmployeeShopList.length; p++) {
          if (checkingEmployeeShopList[p].shopID == NavigationComponent.selectedShopID) {
            this.ecTypeSelectList.push(data.empolyeeList[i]);
            break;
          }
        }

      }

      //set default ec

      var defaultEC: tEmployeeModel = data.defaultEmpolyee;

      if (defaultEC != null && defaultEC != undefined) {
        (<FormControl>this.editForm.controls['bkDoctorName']).setValue(defaultEC.employeeChiName);
        (<FormControl>this.editForm.controls['bkDoctorID']).setValue(defaultEC.employeeID);
      }
     // console.log("bkDoctorName getvalue:"+this.editForm.get('bkDoctorName').value);
      // this.ecTypeSelectList = data.empolyeeList;
      this.getAllData();
    }, error => {
      this.log.i(this.TAG, 'error = ' + JSON.stringify(error));
    });

  }

  getCaseDoctorName(){
    if(!this.selectedPatient) return this.i18n.msg_caseDoctor_no_select_patient
    if(!this.selectedPatient.patientCaseDoctorID) return this.i18n.msg_caseDoctor_no_caseDoctor;

    const caseDr = this.ecTypeSelectList.find(emp=>emp.employeeID === this.selectedPatient.patientCaseDoctorID).employeeChiName;

    return caseDr;
  }

  decodedHKID(){
    if(!this.selectedPatient || !this.selectedPatient.patientIHKID) return '';
    return this.CrypService.decryptStr(this.selectedPatient.patientIHKID);
  }

  patientLastPhysioRemark = "";
  patientLastPhysio = {
    therapistName:'',
    lastDate:''
  };

  getPatientLastPhysioInfo(){
    const {patientID} = this.selectedPatient;
    const shopID = NavigationComponent.selectedShopID.toString();
    this.tOnConsultService.getLastPhysioInfo(shopID,patientID).subscribe(x=>{
      if(x.length > 0){
        const info = x[x.length-1];
        const lastDate = this.datePipe.transform(info.endDateTime,AppSettings.dateFormat);
        this.patientLastPhysio.lastDate = lastDate;
        this.patientLastPhysio.therapistName = info.cltdTherapistName;
        this.patientLastPhysioRemark = "";
      }else{
        this.patientLastPhysioRemark = "";
      }
    });
  }



  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    // event.key === 'ArrowUp'
    if (event.key === SystemDefaultModel.SaveKey) {
      this.log.i(this.TAG, 'onclick F4 , this.apiResultHandlerService.CheckApiResultDialogOpen() = '+this.apiResultHandlerService.CheckApiResultDialogOpen());
     // if (this.apiResultHandlerService.CheckApiResultDialogOpen() === false)
      {
        this.update();
      }
    }
  }

}
